import React from "react";
import Icon from "../../../components/ui/Icon";
import Photo from "../../../components/ui/Photo";
import QuantityStepper from "../../../components/ui/QuantityStepper";
import { formatBRL } from "../../../helpers/currency.helper";
import { ICartProduct, IExtra } from "../../../classes/interfaces";
import {
  Row,
  Thumb,
  Info,
  Name,
  ExtrasLine,
  BottomLine,
  Qty,
  Price,
  RemoveButton,
} from "./CartProductItem.styles";

function buildExtrasLine(product: ICartProduct): string {
  const parts: string[] = [];

  function pushExtras(extras: IExtra[], flavourName?: string) {
    extras.forEach((extra) => {
      const label = flavourName ? `${extra.name} (${flavourName})` : extra.name;
      parts.push(extra.amount > 1 ? `${extra.amount}x ${label}` : label);
    });
  }

  (product.flavours || []).forEach((flavour) => pushExtras(flavour.extras, flavour.product));
  pushExtras(product.extras);

  const extrasText = parts.join(" · ");
  if (!product.obs) return extrasText;
  return [extrasText, `Obs: ${product.obs}`].filter(Boolean).join("  •  ");
}

interface CartProductItemProps {
  product: ICartProduct;
  onRemove: (product: ICartProduct) => void;
  onChangeAmount: (product: ICartProduct, newAmount: number) => void;
}

export default function CartProductItem({ product, onRemove, onChangeAmount }: CartProductItemProps) {
  const line = buildExtrasLine(product);
  const isFlavoured = !!product.flavours && product.flavours.length > 0;

  return (
    <Row>
      <Thumb>
        <Photo src={product.imageUrl || undefined} label={product.product.toLowerCase()} radius={13} />
      </Thumb>
      <Info>
        <Name>{product.product}</Name>
        {line && <ExtrasLine>{line}</ExtrasLine>}
        <BottomLine>
          {isFlavoured ? (
            <Qty>{product.amount}×</Qty>
          ) : (
            <QuantityStepper
              value={product.amount}
              min={1}
              onChange={(value) => onChangeAmount(product, value)}
              size="sm"
            />
          )}
          <Price>{formatBRL(product.total)}</Price>
        </BottomLine>
      </Info>
      <RemoveButton aria-label="Remover produto" onClick={() => onRemove(product)}>
        <Icon name="trash" size={18} />
      </RemoveButton>
    </Row>
  );
}
